import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import notificationQueue from "./NotificationQueue";
import { SnackBar } from "./SnackBar";
export const GlobalSnackBar = () => {
    const [notifications, setNotifications] = React.useState(notificationQueue.notifications || []);
    React.useEffect(() => {
        let dispose = notificationQueue.addListener(() => {
            setNotifications(notificationQueue.notifications);
        });
        return () => {
            dispose();
        };
    }, [setNotifications]);
    const firstNotification = notifications[0];
    function handleClose() {
        notificationQueue.removeNotification(firstNotification);
    }
    if (firstNotification) {
        return _jsx(SnackBar, { notification: firstNotification, onClose: handleClose });
    }
    else {
        return null;
    }
};
//# sourceMappingURL=GlobalSnackBar.js.map